import React from "react";
import {connect} from "react-redux";
import Button from "../elements/Button";
import {openModal} from "../../actions/modal";

class TopBar extends React.Component {

    render() {
        const {openModal} = this.props;
        let callToActionButton;

        if (this.props.cta.enableCallToAction !== false) {
            callToActionButton =    <li><button onClick={() => openModal('cta', this.props.cta)} className={`btn btn-sm btn-success`}>{this.props.cta.buttonText}</button></li>;
        } else {
            callToActionButton = '';
        }
        return (
          <div className="rob-topbar">
              <div className="container">
              <ul className="rob-topbar__left">
                  <li>
                      <Button class={"btn-warning"} text={'Become a member'} />
                  </li>
                  {callToActionButton}
              </ul>
              <ul className="rob-topbar__right">
                  <div className="addthis_inline_share_toolbox">
                      <div className="at-share-btn-elements">
                        <a href="https://www.facebook.com/ayacancernetwork/" className="at-share-link-facebook">
                            <div className="share-box share-facebook">
                            </div>
                        </a>
                        <a href="https://www.instagram.com/ayacancernetwork/" className="at-share-link-instagram">
                            <div className="share-box share-instagram">
                            </div>
                        </a>
                        <a href="https://twitter.com/nzayacancer" className="at-share-link-twitter">
                            <div className="share-box share-twitter">
                            </div>
                        </a>
                        <a href="https://nz.linkedin.com/company/aya-cancer-network-aotearoa" className="at-share-link-linkedin">
                            <div className="share-box share-linkedin">
                            </div>
                        </a>
                      </div>
                  </div>
              </ul>
              </div>
          </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        cta: state.cta
    };
}

export default connect(mapStateToProps, {openModal})(TopBar);



// WEBPACK FOOTER //
// ./src/components/layout/TopBar.js